import {Component, OnInit, ViewChild} from '@angular/core';
import {SwalComponent} from '@sweetalert2/ngx-sweetalert2';
import {NgForm} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-forgotten-password',
    templateUrl: './forgotten-password.component.html',
    styleUrls: ['./forgotten-password.component.scss']
})
export class ForgottenPasswordComponent implements OnInit {
    // @ts-ignore
    @ViewChild(`alert`) private alert: SwalComponent;

    constructor(
        private translateService: TranslateService
    ) {
    }

    ngOnInit(): void {
    }

    onSubmit(forgottenPasswordForm: NgForm) {
        console.log(forgottenPasswordForm.value);
        this.alert.title = this.translateService.instant('general.success');
        this.alert.text = this.translateService.instant('forgottenPassword.successMessage');
        this.alert.icon = 'success';
        this.alert.fire().then();
    }
}
